/**
 * CSV export helper. Generates UTF-8 CSV with BOM (so Excel opens it
 * with proper Cyrillic) and triggers a download.
 */

export interface CsvColumn<T> {
  header: string;
  value: (row: T) => string | number | null | undefined;
}

const escapeCell = (v: unknown): string => {
  if (v === null || v === undefined) return '';
  const s = String(v);
  if (/[",;\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

export const buildCsv = <T,>(rows: T[], columns: CsvColumn<T>[]): string => {
  const head = columns.map((c) => escapeCell(c.header)).join(';');
  const body = rows.map((r) => columns.map((c) => escapeCell(c.value(r))).join(';')).join('\n');
  return `\uFEFF${head}\n${body}`;
};

export const downloadCsv = (filename: string, csv: string) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
